// extracted by mini-css-extract-plugin
export default {"HeaderTitle":"EducationComponent_HeaderTitle__oIZrM","Wrapper":"EducationComponent_Wrapper__6aT7g","buttonWrapper":"EducationComponent_buttonWrapper__egzfB"};